// Timezone enums for events and other components using UTC offset format
export enum TimezoneEnum {
  UTC_MINUS_12 = 'UTC-12:00',
  UTC_MINUS_11 = 'UTC-11:00',
  UTC_MINUS_10 = 'UTC-10:00',
  UTC_MINUS_9 = 'UTC-09:00',
  UTC_MINUS_8 = 'UTC-08:00',
  UTC_MINUS_7 = 'UTC-07:00',
  UTC_MINUS_6 = 'UTC-06:00',
  UTC_MINUS_5 = 'UTC-05:00',
  UTC_MINUS_4 = 'UTC-04:00',
  UTC_MINUS_3_30 = 'UTC-03:30',
  UTC_MINUS_3 = 'UTC-03:00',
  UTC_MINUS_2 = 'UTC-02:00',
  UTC_MINUS_1 = 'UTC-01:00',
  UTC = 'UTC+00:00',
  UTC_PLUS_1 = 'UTC+01:00',
  UTC_PLUS_2 = 'UTC+02:00',
  UTC_PLUS_3 = 'UTC+03:00',
  UTC_PLUS_3_30 = 'UTC+03:30',
  UTC_PLUS_4 = 'UTC+04:00',
  UTC_PLUS_4_30 = 'UTC+04:30',
  UTC_PLUS_5 = 'UTC+05:00',
  UTC_PLUS_5_30 = 'UTC+05:30',
  UTC_PLUS_5_45 = 'UTC+05:45',
  UTC_PLUS_6 = 'UTC+06:00',
  UTC_PLUS_6_30 = 'UTC+06:30',
  UTC_PLUS_7 = 'UTC+07:00',
  UTC_PLUS_8 = 'UTC+08:00',
  UTC_PLUS_9 = 'UTC+09:00',
  UTC_PLUS_9_30 = 'UTC+09:30',
  UTC_PLUS_10 = 'UTC+10:00',
  UTC_PLUS_10_30 = 'UTC+10:30',
  UTC_PLUS_11 = 'UTC+11:00',
  UTC_PLUS_12 = 'UTC+12:00',
  UTC_PLUS_12_45 = 'UTC+12:45',
  UTC_PLUS_13 = 'UTC+13:00',
  UTC_PLUS_14 = 'UTC+14:00',
}

export type TimezoneType = keyof typeof TimezoneEnum;
